import { AutogenModelCarrierActivity, AutogenRowCarrierActivity } from "./autogen/AutogenModelCarrierActivity";

export class ModelCarrierActivity extends AutogenModelCarrierActivity<RowCarrierActivity> {
	constructor() {
		super(RowCarrierActivity);
	}
}

export class RowCarrierActivity extends AutogenRowCarrierActivity {
}